module.exports = __webpack_public_path__ + "img/Projects.e3edb749.svg";